moduleBgSlideShow = angular.module('bgSlideShow.initializer', [])

moduleBgSlideShow.service 'bgSlideShow', ["$timeout", "$injector", "ns", ($timeout, $injector, ns) ->
  'use strict'
  Y = undefined

  bgSlideShow =
    init: (y) ->
      Y = y
      @initSections()
    findSections: ->
      Y.all(ns.sectionClass)
    initSection: ($section, newStyles = false) ->
      jSection = $($section._node)

      if $section.section.background_attributes.images_attributes.length is 1
        jSection.css {backgroundImage: "url(#{$section.section.background_attributes.images_attributes[0].source_url})"}
      else if $section.section.background_attributes.images_attributes.length > 1
        slidesHtml = ""
        _.each $section.section.background_attributes.images_attributes, (image) ->
          if !image._destroy
            slidesHtml += "
              <div class='swiper-slide strw-slider__item' data-slide-id='#{image.id}'>
                <div class='strw-slider__image-wrapper'>
                  <div class='strw-slider__image strw-slider__image_section' style='background-image: url(#{image.source_url})'></div>
                </div>
              </div>
              "
        sliderHtml = "<div class='swiper-container strw-slider strw-slider__section'><div class='swiper-wrapper'>#{slidesHtml}</div></div>"
        jSection.prepend sliderHtml
        jSectionSlider = jSection.find ".strw-slider"
        if newStyles
          styles = angular.copy newStyles
        else
          styles = angular.copy($section.section.style_attributes)
        delete styles.padding
        delete styles.backgroundImage
        jSectionSlider.find(".strw-slider__image").css styles
        $timeout ->
          newSwiperTop = new Swiper $(jSectionSlider), {autoplay: 5000, loop: true, effect: "fade"}
      return
    destroy: (section) ->
      section.all(".strw-slider__section").remove()
      return
    initSections: ->
      self = @
      @findSections().each (section) -> self.initSection(section)
  bgSlideShow
]




// WEBPACK FOOTER //
// ./src/app/editor/section_initializers/bgSlideShow/bgSlideShow.initializer.coffee